var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.83612 3.53017C10.1867 3.18766 10.6583 2.99718 11.1484 3.00003C11.6386 3.00289 12.1079 3.19885 12.4545 3.54542C12.8011 3.89198 12.9971 4.36121 13 4.85132C13.0028 5.34143 12.8123 5.81291 12.4698 6.16349L12.051 6.58224L9.41731 3.94892L9.83612 3.53017ZM8.97472 4.39209L3.96722 9.39896C3.76231 9.60408 3.62008 9.86332 3.55717 10.1463L3.00753 12.6188C2.99604 12.6702 2.99772 12.7237 3.01243 12.7744C3.02714 12.825 3.0544 12.8711 3.09168 12.9083C3.12896 12.9456 3.17504 12.9729 3.22567 12.9876C3.27629 13.0023 3.32981 13.004 3.38126 12.9925L5.839 12.446C6.13163 12.3809 6.3996 12.2337 6.61151 12.0216L11.6084 7.0254L8.97472 4.39209Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.8e684d57a17aa058c4d5c799d4dcb517.svg";
export { ForwardRef as ReactComponent };